import { theme } from '@traba/theme'
import { CSSProperties, ReactNode } from 'react'
import styled from 'styled-components'

export type InfoChipVariant =
  | 'violet'
  | 'grey'
  | 'green'
  | 'orange'
  | 'blue'
  | 'red'

const VARIANT_COLORS: Record<
  InfoChipVariant,
  { color: string; background: string }
> = {
  violet: {
    color: theme.colors.Violet80,
    background: theme.colors.Violet10,
  },
  grey: {
    color: theme.colors.Grey80,
    background: theme.colors.Grey10,
  },
  green: {
    color: theme.colors.Green80,
    background: theme.colors.Green10,
  },
  orange: {
    color: theme.colors.Orange70,
    background: theme.colors.Orange10,
  },
  blue: {
    color: theme.colors.Blue80,
    background: theme.colors.Blue10,
  },
  red: {
    color: theme.colors.Red80,
    background: theme.colors.Red10,
  },
}

export interface InfoChipProps {
  variant?: InfoChipVariant
  children: ReactNode
  size?: 'sm' | 'md'
  iconLeft?: ReactNode
  style?: CSSProperties
}

export function InfoChip({
  variant = 'grey',
  children,
  size = 'md',
  iconLeft,
  style,
}: InfoChipProps) {
  const v = VARIANT_COLORS[variant]
  return (
    <Container
      $color={v.color}
      $background={v.background}
      $size={size}
      style={style}
    >
      {iconLeft && <IconSlot>{iconLeft}</IconSlot>}
      {children}
    </Container>
  )
}

const Container = styled.span<{
  $color: string
  $background: string
  $size: 'sm' | 'md'
}>`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space.xxs}px;
  padding: ${({ $size }) =>
    $size === 'sm'
      ? `2px ${theme.space.xs}px`
      : `${theme.space.ms}px ${theme.space.xs}px`};
  border-radius: ${theme.border.radius};
  background-color: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  font-size: ${({ $size }) => ($size === 'sm' ? '11px' : '12px')};
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
`

const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
`
